import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { Vehicle } from 'src/app/demo/models/common-data-types';
import { LanguageService } from 'src/app/demo/service/language.service';
import { VehiclesService } from 'src/app/demo/service/vehicles.service';
import { ScreenSizeService } from '../../../service/screen-size.service';
import { VehicleListCardComponent } from '../../common/vehicle-list-card/vehicle-list-card.component';
import { ProgressLoaderService } from '../../../service/progress-loader.service';
import { CustomToastrService } from 'src/app/demo/service/custom-toastr.service';

@Component({
    selector: 'app-vehicles-list',
    standalone: true,
    imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    TranslateModule,
    TooltipModule,
    RouterModule,
    VehicleListCardComponent
],
    templateUrl: './vehicles-list.component.html',
    styleUrl: './vehicles-list.component.scss',
})
export class VehiclesListComponent implements OnInit {
    loading: boolean = false;
    vehicles: Vehicle[] = [];
    displayInsuranceModal: boolean = false;
    selectedInsuranceType: string = '';
    currentVehicle: any;
    selectedLanguage: any = '';
    vehiclesPendingDocumentsCount: number = 0;

    constructor(
        private vehiclesService: VehiclesService,
        private messageService: MessageService,
        private router: Router,
        private languageService: LanguageService,
        private translate: TranslateService,
        private screenSizeService: ScreenSizeService,
        private progressLoader: ProgressLoaderService,
        private wiseToastr: CustomToastrService
    ) {}

    ngOnInit(): void {
        this.getCustomerVehicles();
        this.initializeLocale();
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translate.use(language);
        this.languageService.setLanguage(language);
    }

    getMissingDocumentsVehicles(vehicles: Vehicle[]): number {
        return vehicles.filter((vehicle) => {
            return vehicle.status === 'PENDING_DOCUMENT_SUBMISSION';
        }).length;
    }

    getDeviceType(): string {
        return this.screenSizeService.getDeviceType();
    }

    navigateToAddVehicle() {
        this.router.navigate(['/home/vehicles/new']);
    }

    getCustomerVehicles() {
        this.loading = true;
        this.progressLoader.show('Fetching your vehicle');
        this.vehiclesService.getVehicles().subscribe({
            next: (data) => {
                this.loading = false;
                this.progressLoader.hide();
                this.vehicles = data;
                this.vehiclesPendingDocumentsCount =
                    this.getMissingDocumentsVehicles(this.vehicles);
            },
            error: (err) => {
                this.progressLoader.hide();
                this.showErrorToastr(this.translate.instant(err.error.messageKey))
                this.loading = false;
            },
            complete: () => {},
        });
    }

    viewDetails(vehicleId: string) {
        this.router.navigate(['/home/vehicles', vehicleId]);
    }

    delete(vehicleId: string) {
        this.loading = true;
        this.vehiclesService.deleteVehicle(vehicleId).subscribe({
            next: (value: any) => {
                this.loading = false;
                this.showSuccessToastr('Vehicle deleted successfully');
                this.getCustomerVehicles();
            },
            error: (err: any) => {
                this.showErrorToastr(this.translate.instant(err.error.messageKey))
                this.loading = false;
            },
        });
    }

    rowClass(rowData: Vehicle): string {
        return rowData.status === 'PENDING_DOCUMENT_SUBMISSION'
            ? 'call-to-action'
            : '';
    }

    showSuccessToastr(message: string) {
        this.wiseToastr.showSuccess(message);
    }

    showErrorToastr(message: string) {
        this.wiseToastr.showError(message);
    }
}
